export enum AgreementType {
  none = 'None',
  standardEula = 'StandardEula'
}
